import {
  CreateButton,
  Datagrid,
  ExportButton,
  FunctionField,
  List,
  Pagination,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { ListPageIndicator } from "../../components/TablePageIndicator";
import { RaRowActions } from "../../components/RaRowActions";
import { AppBulkDeleteButton } from "../../components/AppBulkDeleteButton";
import { ProductStatusChip, priceFmt } from "./productMeta";
import { colors, radius, shadows } from "../../data/tokens";

// Toolbar padrão + navegação compacta à direita (padrão das listas novas)
const ListActions = () => (
  <TopToolbar sx={{ alignItems: "center" }}>
    <CreateButton />
    <ExportButton />
    <ListPageIndicator />
  </TopToolbar>
);

export const ProductList = () => {
  // O backend de produtos aplica o filtro "name" e a ordenação de
  // qualquer coluna (buildSortFilters) — aqui os controles funcionam.
  const filters = [
    <TextInput label="Buscar por nome" source="name" alwaysOn resettable />,
  ];

  return (
    <>
      <PageTopBreadcrumb
        title="Itens de Cobrança"
        firstPath="/#/products/crud"
        actionType="create"
      />
      <List
        filters={filters}
        actions={<ListActions />}
        perPage={20}
        pagination={<Pagination rowsPerPageOptions={[10, 20, 50]} />}
        // Mantém a página atual visível enquanto a próxima carrega
        queryOptions={{ keepPreviousData: true }}
        sx={{
          // Busca, tabela e paginação dentro do mesmo cartão branco
          "& .RaList-main": {
            backgroundColor: colors.white,
            borderRadius: `${radius.lg}px`,
            boxShadow: shadows.card,
            padding: "4px 20px 8px",
          },
          "& .RaList-content": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
          // Toolbar no fluxo normal: busca à esquerda, ações à direita
          // (anula os hacks antigos do App.css)
          "& .RaList-actions": { alignItems: "center" },
          "& .RaList-actions .MuiToolbar-root": {
            position: "static",
            gap: 1,
          },
          "& .RaFilterForm-filterFormInput": { marginTop: 0 },
        }}
      >
        <Datagrid
          rowClick="show"
          bulkActionButtons={<AppBulkDeleteButton />}
          sx={{
            "& .RaDatagrid-headerCell": {
              fontSize: 11.5,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: colors.textMuted,
              backgroundColor: colors.bgSubtle,
              paddingTop: 1,
              paddingBottom: 1,
            },
            "& .RaDatagrid-rowCell": { paddingTop: 0.75, paddingBottom: 0.75 },
          }}
        >
          <FunctionField
            label="ID"
            sortBy="id"
            render={(record: any) => <IdChip value={record.id} />}
          />
          <TextField source="name" label="Nome" />
          <FunctionField
            label="Preço"
            sortBy="price"
            textAlign="right"
            render={(record: any) =>
              typeof record.price === "number"
                ? priceFmt.format(record.price)
                : "—"
            }
          />
          <FunctionField
            label="Máx. de parcelas"
            sortBy="maxInstallments"
            textAlign="right"
            render={(record: any) =>
              record.maxInstallments ? `${record.maxInstallments}x` : "—"
            }
          />
          <FunctionField
            label="Situação"
            sortBy="status"
            textAlign="center"
            render={(record: any) => (
              <ProductStatusChip status={record.status} />
            )}
          />
          <FunctionField
            label="Ações"
            textAlign="right"
            render={() => <RaRowActions />}
          />
        </Datagrid>
      </List>
    </>
  );
};
